import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconJourney(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M18 3C18 1.34315 19.3431 0 21 0C22.6569 0 24 1.34315 24 3V12C24 13.6569 22.6569 15 21 15C19.3431 15 18 13.6569 18 12V3Z"
        fill="currentColor"
      />
      <path
        d="M0 12C0 10.3431 1.34315 9 3 9C4.65685 9 6 10.3431 6 12V21C6 22.6569 4.65685 24 3 24C1.34315 24 0 22.6569 0 21V12Z"
        fill="currentColor"
      />
      <path
        d="M12 -1.31134e-07C13.6569 -5.87108e-08 15 1.34315 15 3C15 4.65685 13.6569 6 12 6L3 6C1.34315 6 -2.03558e-07 4.65685 -1.31134e-07 3C-5.87108e-08 1.34315 1.34315 -5.9696e-07 3 -5.24537e-07L12 -1.31134e-07Z"
        fill="currentColor"
      />
      <path
        d="M21 18C22.6569 18 24 19.3431 24 21C24 22.6569 22.6569 24 21 24L12 24C10.3431 24 9 22.6569 9 21C9 19.3431 10.3431 18 12 18L21 18Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
